import { render, staticRenderFns } from "./DeleteItemGeneral.vue?vue&type=template&id=28e5cb2a&scoped=true&"
import script from "./DeleteItemGeneral.vue?vue&type=script&lang=js&"
export * from "./DeleteItemGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5cb2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
